import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { normalizeRawMessage } from '../utils/normalizeRawMessage';

export const DEVICE_READING_RAW_DATA_QUERY = `
	query getDeviceReadingRawData($unitId: String!, $eventId: Float!) {
		RawData: getDeviceReadingRawData(unitId: $unitId, eventId: $eventId) {
			id
			unitId
			unitTime
			eventCode
			eventName
			manufacturerName
			rawMessage
		}
	}
`;

/**
 * One reading's raw OEM message (general API, Cognito). Resolves to null when
 * the API has no row for `(unitId, eventId)` — never undefined, which
 * TanStack Query v5 rejects.
 */
export const getDeviceReadingRawData = async (unitId, eventId) => {
	const res = await clientQuery(
		DEVICE_READING_RAW_DATA_QUERY,
		{ unitId: String(unitId), eventId: Number(eventId) },
		endpoints.GRAPHQL_GENERAL_V2,
	);
	const rawData = res?.RawData;
	if (!rawData) return null;
	return { ...rawData, rawMessage: normalizeRawMessage(rawData.rawMessage) };
};
